import React from "react";
import PartialShipmentsTab from "./PartialShipmentsTab";
import { FILTER_TABS } from "./Utils/sortableColumns";

const DropTrailers = ({ searchQuery, filter, searchTrigger, setTotalShipments, stateKey = "drop-trailers" }) => {
  const config = {
    moduleName: "Drop Trailers",
    apiEndpoint: "/api/shipment-details/partial-search-drop-trailer",
    paginationLabel: "Drop Trailers per page",
    filterType: FILTER_TABS.DT,
    defaultPageSize: 50,
  };

  return (
    <PartialShipmentsTab
      config={config}
      searchQuery={searchQuery}
      filter={filter}
      searchTrigger={searchTrigger}
      setTotalShipments={setTotalShipments}
      stateKey={stateKey}
      enableAdvancedFilters
    />
  );
};

export default DropTrailers;
